import { useEffect, useState } from 'react';
import { FormSettingField, getFormSettingPreview } from 'src/shared/services/memberFormSettingsService';

/**
 * Hämtar ett medlemsformulärs fält (SAMMA källa som "Redigera medlem"/dynamicFormField använder) och
 * returnerar dem som en Map<fieldName, FormSettingField> tillsammans med laddningsstatus.
 *
 * Använder getFormSettingPreview (FormSetting/{formName}/Preview) som ger varje fält dess `options`
 * (t.ex. landslistan för Country-fältet och alternativen för droplistor) — det gör getFormSettingFields
 * INTE. Options mappas in i FormSettingField.extraOptions så sektionen kan rendera riktiga droplistor.
 *
 * Används av den formulärstyrda sektionen "Medlemsuppgifter" i utökad medlemssök. formName är 'member'
 * för medlemsregistret och 'other' för intressentregistret.
 */
export const useMemberFormFields = (formName = 'member') => {
  const [fields, setFields] = useState<Map<string, FormSettingField>>(new Map());
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getFormSettingPreview(formName)
      .then((res) => {
        if (!active) return;
        const map = new Map<string, FormSettingField>();
        (res.data?.items ?? []).forEach((item) => {
          const setting = item.formSetting;
          if (setting?.fieldName) {
            // Slå ihop fältets inställning med dess options → FormSettingField med extraOptions,
            // så droplistor (land, m.fl.) får sina alternativ från samma källa som formuläret.
            map.set(setting.fieldName.trim(), { ...setting, extraOptions: item.options } as unknown as FormSettingField);
          }
        });
        setFields(map);
      })
      .catch(() => undefined)
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [formName]);

  return { fields, loading };
};

export default useMemberFormFields;
